import React from 'react';
import { Chip, useTheme } from '@mui/material';

const TechnicalMeta = ({ label, variant = 'outlined', size = 'small', sx = {} }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  if (!label || String(label).trim() === '') return null;

  const getColorTheme = (text) => {
    const t = String(text || '').toUpperCase();
    if (t.includes('READING') || t.includes('ACTIVE') || t.includes('COMPLETED') || t.includes('RANK 1') || t.includes('1867')) {
      return {
        color: isDark ? '#34d399' : '#059669',
        border: isDark ? 'rgba(52, 211, 153, 0.35)' : 'rgba(5, 150, 105, 0.3)',
        bg: isDark ? 'rgba(52, 211, 153, 0.1)' : 'rgba(5, 150, 105, 0.08)',
      };
    }
    if (t.includes('IN PROGRESS') || t.includes('DRAFTING') || t.includes('STEALTH') || t.includes('TO READ') || t.includes('QUEUED')) {
      return {
        color: isDark ? '#fbbf24' : '#d97706',
        border: isDark ? 'rgba(251, 191, 36, 0.35)' : 'rgba(217, 119, 6, 0.3)',
        bg: isDark ? 'rgba(251, 191, 36, 0.1)' : 'rgba(217, 119, 6, 0.08)',
      };
    }
    if (t.includes('BOOK') || t.includes('MANUSCRIPT') || t.includes('PHILOSOPHY') || t.includes('ESSAY')) {
      return {
        color: isDark ? '#c084fc' : '#7c3aed',
        border: isDark ? 'rgba(192, 132, 252, 0.35)' : 'rgba(124, 58, 237, 0.3)',
        bg: isDark ? 'rgba(192, 132, 252, 0.1)' : 'rgba(124, 58, 237, 0.08)',
      };
    }
    if (t.includes('SYSTEMS') || t.includes('ENGINEERING') || t.includes('CODEFORCES') || t.includes('C++') || t.includes('COMPUTING')) {
      return {
        color: isDark ? '#38bdf8' : '#0284c7',
        border: isDark ? 'rgba(56, 189, 248, 0.35)' : 'rgba(2, 132, 199, 0.3)',
        bg: isDark ? 'rgba(56, 189, 248, 0.1)' : 'rgba(2, 132, 199, 0.08)',
      };
    }
    return {
      color: theme.palette.secondary.main,
      border: isDark ? 'rgba(229, 169, 60, 0.3)' : 'rgba(184, 134, 11, 0.25)',
      bg: isDark ? 'rgba(229, 169, 60, 0.08)' : 'rgba(184, 134, 11, 0.06)',
    };
  };

  const style = getColorTheme(label);

  return (
    <Chip
      label={label}
      size={size}
      variant={variant}
      sx={{
        fontFamily: '"JetBrains Mono", monospace',
        fontSize: '0.74rem',
        fontWeight: 700,
        letterSpacing: '0.04em',
        borderRadius: '8px',
        height: '24px',
        borderColor: style.border,
        backgroundColor: style.bg,
        color: style.color,
        transition: 'all 180ms ease',
        '&:hover': {
          borderColor: style.color,
          transform: 'translateY(-1px)',
        },
        ...sx,
      }}
    />
  );
};

export default TechnicalMeta;
